import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})

export class MenuProvider {

  private readonly showMobileMenu = signal<boolean>(true);

  readonly readShowMobileMenu = this.showMobileMenu.asReadonly();

  setShowMobileMenu(flag: boolean) {
    this.showMobileMenu.set(flag);
  }
}
